import React from 'react'
import styles from '../../../CSS/main.css'

type Props = {
  readonly iconBlock: JSX.Element
}

const InfoCard: React.FC<Props> = ({ children, iconBlock }) => {
  return (
    <div className={styles.UserCard}>
      <div className={styles.UserCardLeft}>{iconBlock}</div>
      <div className={styles.UserCardRight}>{children}</div>
    </div>
  )
}

export default InfoCard
